module.exports = __webpack_public_path__ + "media/images/benefit-earth-263c6e0df5259947a742232aea41431a.svg";